import React from "react";

export default function PageNotFound() {
  return (
    <div className="flex h-screen flex-col items-center justify-center space-y-8 bg-gray-100 text-center">
      <img
        // src="https://media.giphy.com/media/14uQ3cOFteDaU/giphy.gif"
        // src="https://media.giphy.com/media/VwoJkTfZAUBSU/giphy.gif"
        // src="https://media.giphy.com/media/JIX9t2j0ZTN9S/giphy.gif"
        // src="https://media.giphy.com/media/13HgwGsXF0aiGY/giphy.gif"
        src="https://media.giphy.com/media/l2JehQ2GitHGdVG9y/giphy.gif"
        alt="Page Not Found"
        className="h-64 w-64 object-cover"
      />
      <h1 className="text-5xl font-bold text-red-600">
        Oops! 404 - Page Not Found
      </h1>
      <p className="text-lg text-gray-600">
        The page you're looking for doesn't exist.
      </p>
      <a
        href="/auth/sign-in"
        className="rounded-md bg-blue-500 px-4 py-2 text-white transition hover:bg-blue-700"
      >
        Go back to Homepage
      </a>
    </div>
  );
}
